import React from "react";
import { FiSun, FiMoon } from "react-icons/fi";
import { useTheme } from "../../context/ThemeContext";

const ThemeToggle = ({ className = "", iconClassName = "w-5 h-5" }) => {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={
        className ||
        "p-2.5 rounded-xl transition-all duration-300 border text-slate-700 dark:text-slate-200 border-transparent hover:border-emerald-200 hover:bg-emerald-50 dark:hover:bg-slate-800 dark:hover:border-slate-700"
      }
    >
      {isDark ? <FiSun className={iconClassName} /> : <FiMoon className={iconClassName} />}
    </button>
  );
};

export default ThemeToggle;
